/* rhoneprints: quiet generated sounds (swish, click, static, blips). on by default; a visitor can switch it off. */
(function () {
  'use strict';
  var KEY = 'gl-sound';
  var on = true;
  try { var saved = localStorage.getItem(KEY); if (saved !== null) on = saved === '1'; } catch (e) {}
  var AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;

  var ctx = null, master = null, noiseBuf = null;
  function ensure() {
    if (!ctx) {
      ctx = new AC();
      master = ctx.createGain();
      master.gain.value = 0.6;
      master.connect(ctx.destination);
      noiseBuf = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
      var d = noiseBuf.getChannelData(0);
      for (var i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    }
    if (ctx.state === 'suspended') ctx.resume();
    return ctx.state !== 'closed';
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }

  function noise(dur, type, f0, f1, q, vol) {
    var src = ctx.createBufferSource();
    src.buffer = noiseBuf;
    src.loop = true;
    var f = ctx.createBiquadFilter();
    f.type = type;
    var t = ctx.currentTime;
    f.frequency.setValueAtTime(f0, t);
    f.frequency.exponentialRampToValueAtTime(f1, t + dur);
    f.Q.value = q;
    var g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.linearRampToValueAtTime(vol, t + dur * 0.35);
    g.gain.linearRampToValueAtTime(0.0001, t + dur);
    src.connect(f); f.connect(g); g.connect(master);
    src.start(t, Math.random() * 0.5);
    src.stop(t + dur + 0.02);
  }
  function tone(freq0, freq1, dur, type, vol) {
    var o = ctx.createOscillator();
    o.type = type;
    var t = ctx.currentTime;
    o.frequency.setValueAtTime(freq0, t);
    o.frequency.exponentialRampToValueAtTime(Math.max(30, freq1), t + dur);
    var g = ctx.createGain();
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(master);
    o.start(t); o.stop(t + dur + 0.02);
  }

  function swish(v) { if (on && ensure()) noise(0.11, 'bandpass', rnd(500, 900), rnd(1800, 3200), 1.1, v); }
  function click() {
    if (!on || !ensure()) return;
    tone(1300, 320, 0.06, 'square', 0.018);
    noise(0.03, 'highpass', 3500, 6000, 0.7, 0.014);
  }
  function blip() {
    if (!on || !ensure()) return;
    var f = [660, 880, 990, 1320, 1760][Math.floor(Math.random() * 5)];
    tone(f, f, rnd(0.035, 0.07), 'triangle', 0.015);
    if (Math.random() < 0.4) setTimeout(function () { if (on) tone(f * 1.5, f * 1.5, 0.04, 'triangle', 0.011); }, 80);
  }
  function stat() {
    if (!on || !ensure()) return;
    var n = 2 + Math.floor(Math.random() * 3);
    for (var i = 0; i < n; i++) {
      (function (k) { setTimeout(function () { if (on && ctx) noise(rnd(0.03, 0.07), 'highpass', rnd(2500, 5000), rnd(5000, 9000), 0.6, rnd(0.008, 0.018)); }, k * rnd(40, 90)); })(i);
    }
  }
  function chirp(up) {
    if (!on || !ensure()) return;
    tone(up ? 440 : 880, up ? 880 : 440, 0.09, 'triangle', 0.03);
    setTimeout(function () { if (ctx) tone(up ? 660 : 660, up ? 1320 : 330, 0.08, 'triangle', 0.022); }, 90);
  }

  /* on/off button */
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'gl-sound';
  var st = document.createElement('style');
  st.textContent =
    '.gl-sound{position:fixed;left:14px;bottom:14px;z-index:9999;padding:.7rem 1.1rem;font:inherit;font-size:1.2rem;letter-spacing:.14em;text-transform:lowercase;color:#f2efff;background:rgba(10,10,16,.85);border:1px solid rgba(34,230,255,.7);cursor:pointer}' +
    '.gl-sound:hover{box-shadow:-2px 0 0 #22e6ff,2px 0 0 #ff2fd0}' +
    '.gl-sound[aria-pressed=true]{border-color:#ff2fd0}';
  document.head.appendChild(st);
  var hero = null;
  function btns() { return [btn].concat(Array.prototype.slice.call(document.querySelectorAll('[data-gl-sound]'))); }
  function paint() {
    btns().forEach(function (b) {
      b.textContent = on ? 'sound: on' : 'sound: off';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'turn sound off' : 'turn sound on');
    });
  }
  function toggle(e) {
    e.stopPropagation();
    on = !on;
    try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (x) {}
    paint();
    if (on) { ensure(); chirp(true); } else if (ctx) { ctx.suspend(); }
  }
  paint();
  btn.addEventListener('click', toggle);
  function findHero() {
    if (hero) return;
    hero = document.querySelector('[data-gl-sound]');
    if (!hero) return;
    hero.addEventListener('click', toggle);
    paint();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        btn.style.display = en[0].isIntersecting ? 'none' : '';
      }).observe(hero);
    }
  }
  function mount() { if (document.body && !btn.parentNode) document.body.appendChild(btn); findHero(); }
  mount();
  document.addEventListener('DOMContentLoaded', mount);

  /* the browser only lets audio start after the first click, tap or key press */
  function unlock() { if (on) ensure(); }
  ['pointerdown', 'touchend', 'keydown'].forEach(function (t) { document.addEventListener(t, unlock, { once: true, passive: true }); });

  /* click sound */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.gl-sound, [data-gl-sound]')) return;
    click();
  }, true);

  /* cursor swish: very soft, once in a while as the mouse travels */
  var lx = null, ly = null, dist = 0, lastT = 0, lastS = 0;
  window.addEventListener('mousemove', function (e) {
    if (!on) { lx = null; return; }
    var now = performance.now();
    if (lx === null) { lx = e.clientX; ly = e.clientY; lastT = now; return; }
    var dx = e.clientX - lx, dy = e.clientY - ly;
    lx = e.clientX; ly = e.clientY;
    dist += Math.sqrt(dx * dx + dy * dy);
    var dt = Math.max(1, now - lastT);
    lastT = now;
    if (dist >= 180 && now - lastS > 140) {
      var speed = Math.min(2.5, dist / dt);
      swish(0.003 + Math.min(0.006, speed * 0.003));
      dist = 0; lastS = now;
    }
  }, { passive: true });

  /* now and then: static or a blip */
  function ambient() {
    if (on && !document.hidden) { if (Math.random() < 0.55) stat(); else blip(); }
    setTimeout(ambient, rnd(6000, 15000));
  }
  setTimeout(ambient, 7000);
})();
